export const TRANSITION_DURATION_FAST = 200;
export const TRANSITION_DURATION_SLOW = 400;
